// Internal modules
import { STATE_NAME } from '@/lib/logger';

const TRANSITION_NAME = {
  prepareDcc: 'prepare_currency_conversion',
  processDccSelection: 'process_currency_conversion_selection',
};

export const PROCESS_CURRENCY_CONVERSION_SELECTION = selection => ({
  conversion_selection: selection,
  state_name: STATE_NAME.billing,
  transition_name: TRANSITION_NAME.processDccSelection,
});
